module.exports = __webpack_public_path__ + "static/media/aggregator-pin.ed96845e.svg";